// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c9944ae9","128":"da3a7018","280":"fa6c91aa","444":"731a09e1","460":"9ca72a97","476":"4f3bf74a","477":"439e240c","535":"946836a2","553":"b68a3ce1","693":"dc31b58b","916":"aa9b9b56"}[chunkId] + ".chunk.js";
};